/* =========================================================================
   Tiny CTA/opener registry for the Journey Director. Journey suggestions carry a
   target ('play' | 'arcade' | 'gtky' | 'feast'); the code that owns each
   destination registers an opener here at boot, and the journey card
   feature-detects with hasOpener() before showing a CTA button. This lets a
   Wave-4 screen (e.g. the feast flow) light up its CTA the moment it registers,
   with zero edits to journey.ts — and keeps the journey card button hidden while
   that screen is still absent.
   ========================================================================= */
export type CtaTarget = 'play' | 'arcade' | 'gtky' | 'feast';

const openers = new Map<CtaTarget, () => void>();

/** Register the function that navigates to / launches a CTA target. */
export function registerOpener(target: CtaTarget, fn: () => void): void {
  openers.set(target, fn);
}

/** True when a target has a registered opener (drives CTA-button visibility). */
export function hasOpener(target: CtaTarget): boolean {
  return openers.has(target);
}

/** Invoke a target's opener if present; returns whether it ran. */
export function openTarget(target: CtaTarget): boolean {
  const fn = openers.get(target);
  if (!fn) return false;
  fn();
  return true;
}

/** Test/reset hook. */
export function resetOpeners(): void {
  openers.clear();
}
